module.exports = __webpack_public_path__ + "f56e08b1f8f3b723e415a8459246a9d2.png";